import { Typography } from '@trackman/web-shared-components';

import ReportPageHeader from './ReportPageHeader';
import { useTranslation } from 'react-i18next';
import { DateRangeDto } from 'types/CodegenReportTypes';
import { displayDate } from 'utilities/dateHelpers';

type Props = {
  playerName?: string;
  teamName?: string;
  seasonNames?: string[];
  dateRanges?: DateRangeDto[];
};

const PlayerReportHeader = ({ playerName, teamName, seasonNames, dateRanges }: Props) => {
  const { t } = useTranslation();
  return (
    <ReportPageHeader>
      <Typography variant='h2' component='div' color='#414141'>
        {playerName ?? t('Player’s name')}
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        |
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        {teamName ?? t('Team’s name')}
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        |
      </Typography>
      <Typography variant='body' component='div' color='#414141'>
        {seasonNames?.length
          ? seasonNames.join(', ')
          : dateRanges && dateRanges.length
            ? dateRanges.map((range) => `${displayDate(range.utcDateFrom)} - ${displayDate(range.utcDateTo)}`).join(', ')
            : t('Time period')}
      </Typography>
    </ReportPageHeader>
  );
};

export default PlayerReportHeader;
